import { createStore, compose, applyMiddleware } from 'redux';
import sagaMiddlewareFactory from 'redux-saga';
import thunkMiddleware from 'redux-thunk'; //check out https://github.com/gaearon/redux-thunk for how to use this
import rootReducer from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = sagaMiddlewareFactory();
const middlewares = [thunkMiddleware, sagaMiddleware];
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(rootReducer, {}, composeEnhancers(applyMiddleware(...middlewares)));
sagaMiddleware.run(rootSaga);
export default store;
